export default __webpack_public_path__ + "static/media/Imp_hitch_avl.642365f8.svg";